import * as angular from 'angular';

import LogoController from "./controllers/logo.controller";
import StandardComponent from "components/standards/components/StandardComponent";

"use strict";

class Logo extends StandardComponent {

    // This will enable the debug mode of this class
    public debug = false;
    public moduleFolder = 'components/blocworx/components/logo';

    /**
     * PLease make sure that each function contain correct
     * documentation.
     */
    public bindings = {
        bootstrap: '<',
    }

    // This will set what will be the controller of this component
    public controller : any = LogoController;

    // This will set an alias
    public controllerAs: string = 'logo';
}

angular.module('BlocworxModule').component('blocworxLogo', <StandardComponent> new Logo);